import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, CheckCircle2 } from 'lucide-react';
export function PurchaseNotification() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 8000);
    const hideTimer = setTimeout(() => setIsVisible(false), 18000);
    return () => {
      clearTimeout(timer);
      clearTimeout(hideTimer);
    };
  }, []);
  return <AnimatePresence data-id="element-178">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-4 right-4 md:bottom-8 md:right-8 z-50 max-w-sm w-[calc(100%-2rem)]" data-id="element-179">
          <div className="bg-white rounded-xl shadow-2xl border border-zinc-200 p-4 pr-10 relative overflow-hidden" data-id="element-180">
            <div className="absolute left-0 top-0 bottom-0 w-1 bg-sky-500" data-id="element-181"></div>

            <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-zinc-400 hover:text-zinc-600 p-1" aria-label="Cerrar notificación" data-id="element-182">
              <X className="w-4 h-4" data-id="element-183" />
            </button>

            <div className="flex items-start gap-3" data-id="element-184">
              <div className="mt-0.5 shrink-0" data-id="element-185">
                <CheckCircle2 className="w-5 h-5 text-sky-500" data-id="element-186" />
              </div>
              <div data-id="element-187">
                <p className="text-xs font-bold text-sky-600 uppercase tracking-wider mb-1" data-id="element-188">
                  Compra verificada
                </p>
                <p className="text-sm text-zinc-700 leading-tight" data-id="element-189">
                  <strong data-id="element-190">Martín R.</strong> de Buenos Aires compró
                  <br data-id="element-191" />
                  <span className="text-sky-700 font-medium" data-id="element-192">
                    Megapack Stickers Mundial 🇦🇷⭐
                  </span>
                </p>
                <p className="text-xs text-zinc-400 mt-2" data-id="element-193">Hace 4 minutos</p>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}